import clsx from 'clsx';
import styles from './FillInfoCard.module.css';

export const FillInfoCard = ({
  children,
  dataTestId,
  className = '',
}: {
  children: React.ReactNode;
  dataTestId?: string;
  className?: string;
}) => {
  return (
    <div
      className={clsx(styles.fillInfoCard, className)}
      data-testid={dataTestId || 'fill-info-card'}
    >
      {children}
    </div>
  );
};
